import React, { useReducer } from 'react';
import Cookies from 'universal-cookie';
import api from './ApiCall';
import { LOGIN_DETAILS, LOGIN_ERROR, AUTH_LOGIN, LoginContext} from './../constant/ActionTypes';
import { loginReducer } from './../reducer/loginReducer';

const cookies = new Cookies();

const initialState = {
    loginDetails: {},
    loginError: '',
    authLogin: false
}

const LoginProvider = (props) => {
    const [loginState, dispatch] = useReducer(loginReducer, initialState);

    const onLoginSubmit = (data, history) => {
        let date = new Date();
        let expiryDate = date.setDate(date.getDate() + 1);
        let maxAge = new Date(expiryDate).getTime();

        api({ contentType: true, auth: true }).post('LoginService/login', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success' && response.data.result) {

                cookies.set('auth', true, { path: '/', maxAge });
                cookies.set('loginDetails', response.data.result, { path: '/', maxAge });

                updateAuth(true);
                updateLoginDetails(response.data.result);
                history.push('/');
            } else {
                dispatch({
                    type: LOGIN_ERROR,
                    payload: 'username or password is invalid'
                });
            }
        })
        .catch((error) => {
            console.log(error);
            dispatch({
                type: LOGIN_ERROR,
                payload: 'Server Timeout'
            });
        });
    }

    //forget password
    const onForgetSubmit = (data) => {

        api({ contentType: true, auth: true }).post('UserService/forgotPassword', data)
        .then((response) => {
            if(response.data.message === 'User with this email is not registered'){
                dispatch({
                    type: LOGIN_ERROR,
                    payload: response.data.message
                });
            }
            
        })
        .catch((error) => {
            console.log(error);
            // dispatch({
            //     type: LOGIN_ERROR,
            //     payload: 'Server Timeout'
            // });
        });
    }

    const updateLoginDetails = (val) => {
        dispatch({
            type: LOGIN_DETAILS,
            payload: val
        });
    }

    const updateAuth = (val) => {
        if (!val) {
            cookies.remove('auth', { path: '/' });
            cookies.remove('loginDetails', { path: '/' });
        }
        dispatch({
            type: AUTH_LOGIN,
            payload: val
        });
    }

    return (
        <LoginContext.Provider
			value={{
				...loginState,
                onLoginSubmit: onLoginSubmit,
                onForgetSubmit: onForgetSubmit,
                updateAuth: updateAuth,
                updateLoginDetails: updateLoginDetails
			}}
		>
			{props.children}
		</LoginContext.Provider>
    );
}

export default LoginProvider;



// WEBPACK FOOTER //
// ./contexts/provider/LoginContext.js